export class TimesheetUnitsHandler {
  private codesForTwoConsumers = [182, 184, 186, 188, 195, 196, 199, 200, 201];

  private fixedOneUnits = [202];

  private serviceCodeConfig: any = {
    // Mapping service codes to config keys
    "2401": "hourlyUnits",
    "2402": "hourlyUnits",
    "2403": "hourlyUnits",
    "2404": "hourlyUnits",
    "T1019": "fifteenMinUnit",
    "2422": "fifteenMinUnit",
    "2423": "fifteenMinUnit",
    "2424": "fifteenMinUnit",
    "2425": "fifteenMinUnit",
    "T1020": "fixed52Unit",
    "2405": "fixed52Unit",
    "2406": "fixed52Unit",
    "default": "fifteenMinUnit",

    // Shared configuration map
    configMap: {
      fifteenMinUnit: {
        default: {
          isHourly: false,
          increment: 1,
          thresholdMap: [
            { maxMinutes: 22, units: 1 }
          ],
          extendWithStep: {
            fromMinutes: 22,
            stepMinutes: 15,
            unitStep: 1
          }
        }
      },
      hourlyUnits: {
        default: {
          isHourly: true,
          thresholdMap: [
            { maxMinutes: 89, units: 4 }
          ],
          extendWithStep: {
            fromMinutes: 89,
            stepMinutes: 60,
            unitStep: 4
          }
        }
      },
      fixed52Unit: {
        default: {
          isHourly: false,
          increment: 52
        }
      }
    }
  };

  constructor() { }

  public calculateBilledUnits(
    serviceTimeIn: Date | null,
    serviceTimeOut: Date | null,
    serviceCodeLkp: string,
    serviceCodeDetailId: any
  ): number | null {
    const isInFixedOneUnits = this.fixedOneUnits.includes(serviceCodeDetailId);
    if (isInFixedOneUnits) {
      const diffInMinutes = this.calculateTimeDifference(serviceTimeIn, serviceTimeOut);
      if (diffInMinutes == null || diffInMinutes <= 0) return 0;

      return 4;
    }

    const isTwoConsumers = this.codesForTwoConsumers.includes(serviceCodeDetailId);
    const configKey = this.serviceCodeConfig[serviceCodeLkp] ?? "default";
    const serviceDetails = this.serviceCodeConfig.configMap[configKey] ?? this.serviceCodeConfig.configMap["fifteenMinUnit"];

    if (!serviceDetails) return null;

    const serviceConfig = serviceDetails[serviceCodeDetailId] || serviceDetails["default"];
    if (serviceConfig) {
      return this.handleServiceCode(serviceConfig, isTwoConsumers, serviceTimeIn, serviceTimeOut);
    }

    return null;
  }

  private handleServiceCode(
    config: any,
    isTwoConsumers: boolean,
    serviceTimeIn: Date | null,
    serviceTimeOut: Date | null
  ): number {
    const diffInMinutes = this.calculateTimeDifference(serviceTimeIn, serviceTimeOut);
    if (diffInMinutes == null || diffInMinutes <= 0) return 0;

    let billedUnits = 0;

    if (config.thresholdMap) {
      let matched = false;
      for (const threshold of config.thresholdMap) {
        if (diffInMinutes <= threshold.maxMinutes) {
          billedUnits = threshold.units;
          matched = true;
          break;
        }
      }

      if (!matched && config.extendWithStep) {
        const { fromMinutes, stepMinutes, unitStep } = config.extendWithStep;
        const lastThreshold = config.thresholdMap[config.thresholdMap.length - 1];
        const extraMinutes = diffInMinutes - fromMinutes;
        const steps = Math.ceil(extraMinutes / stepMinutes);
        billedUnits = lastThreshold.units + (steps * unitStep);
      }

      if (config.increment) {
        billedUnits *= config.increment;
      }
    } else if (config.increment) {
      billedUnits = config.increment;
    }

    if (isTwoConsumers) {
      billedUnits /= 2;
    }

    return billedUnits;
  }

  public calculateTimeDifference(timeIn: Date | null, timeOut: Date | null): number | null {
    if (!timeIn || !timeOut) return null;
    const timeInDate = new Date(timeIn.setSeconds(0, 0));
    const timeOutDate = new Date(timeOut.setSeconds(0, 0));
    const diffInMs = timeOutDate.getTime() - timeInDate.getTime();
    return diffInMs / (1000 * 60); // return difference in minutes
  }
}